import { Preferences } from '@capacitor/preferences';

const AUTH_TOKEN_KEY = 'auth_token';

let cachedToken: string | null = null;

export async function hydrateMobileAuthToken(): Promise<void> {
    if (!window.CORDOVA) return;

    const { value } = await Preferences.get({ key: AUTH_TOKEN_KEY });
    if (value) {
        cachedToken = value;
    } else {
        // One-time migration: if the token still lives in localStorage from a
        // previous app version, copy it into Preferences so future WKWebView
        // localStorage purges can't wipe the user's session.
        const legacyToken = window.localStorage.getItem(AUTH_TOKEN_KEY);
        if (legacyToken) {
            cachedToken = legacyToken;
            await Preferences.set({ key: AUTH_TOKEN_KEY, value: legacyToken });
            window.localStorage.removeItem(AUTH_TOKEN_KEY);
        }
    }
}

export function getMobileAuthToken(): string | null {
    return cachedToken;
}

export async function setMobileAuthToken(token: string): Promise<void> {
    if (!window.CORDOVA) return;
    cachedToken = token;
    await Preferences.set({ key: AUTH_TOKEN_KEY, value: token });
}

export async function clearMobileAuthToken(): Promise<void> {
    if (!window.CORDOVA) return;
    cachedToken = null;
    await Preferences.remove({ key: AUTH_TOKEN_KEY });
}
